export default {
    messages: null,
    chat: null
};
